import styled from 'styled-components';

export const Datestamp = styled.div`
  font-size: 12px;
  color: ${({ theme }) => theme.color.gray[900].value};
  text-align: right;
  white-space: normal;
  overflow-wrap: break-word;
`;
